// @ts-ignore
import {version} from '../package.json';

const matches = version.match(/([0-9]+).([0-9]+).([0-9]+)(?:-rc.([0-9]+))?/);
if (!matches || matches.length < 4) {
    console.error(`Invalid version '${version}'. Expected: major.minor.patch[-rc.x]`);
}

/**
 * Version type following a subset of the Semantic Versioning specification.
 */
export type Version = {major: number; minor: number; patch: number; rc: number};

/** Version of this API. */
export const APIVersion: Version = {
    major: Number.parseInt(matches![1]),
    minor: Number.parseInt(matches![2]),
    patch: Number.parseInt(matches![3]),
    rc: matches![4] !== undefined ? Number.parseInt(matches![4]) : 0,
};
